import cn from 'classnames'
import { Icon } from '../../icon'
import { FormField } from '../form-field'
import styles from './BaseField.module.css'
import { BaseFieldProps, ValidationStatuses } from './BaseField.types'

export function ValidationIcon({ status, className }: { status: ValidationStatuses, className?: string }) {
  if (status === 'default') {
    return null
  }

  const iconClassName = cn(
    {
      [styles.validationIconSuccess]: status === 'success',
      [styles.validationIconError]: status === 'error',
    },
    className,
  )

  return (
    <Icon
      size={20}
      glyph={status === 'error' ? 'ExclamationInCircle' : 'CheckMarkInCircle'}
      className={iconClassName}
      data-testid={`status-icon-${status}`}
    />
  )
}

export function BaseField({
  disabled,
  status,
  label,
  helpText,
  feedbackText,
  attributes,
  children,
  className,
  formFieldClass,
  optionalLabel,
  name,
}: React.PropsWithChildren<BaseFieldProps>) {
  const baseFieldClassName = cn(
    styles.baseField,
    {
      [styles.baseFieldDisabled]: disabled,
      [styles.baseFieldStatusSuccess]: status === 'success',
      [styles.baseFieldStatusError]: status === 'error',
    },
    className,
  )

  const wrapper = (
    <div className={baseFieldClassName} {...attributes}>
      {children}
    </div>
  )

  if (label || helpText || feedbackText) {
    return (
      <FormField name={name} disabled={disabled} label={label} helpText={helpText} feedbackText={feedbackText} status={status} className={formFieldClass} optionalLabel={optionalLabel}>
        {wrapper}
      </FormField>
    )
  }

  return wrapper
}

export default { BaseField, ValidationIcon }
